import { searchService } from '@services';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './related-searches-facet.component.hbs';

export class RelatedSearchesFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'relatedSearchesFacet';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.values?.length) {
            return '';
        }

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        super.bindChildElements();

        this.shadowRoot?.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query);
                }
            });
        });
    }
}
